import React from 'react';
import PropTypes from 'prop-types';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';

import { Events } from '../services/Constants';
import {
  addEvent,
  checkSkyanAuthorization,
  saveAuthentication,
} from '../actions';

export class Authenticated extends React.Component {
  componentDidUpdate() {
    const {
      addEvent,
      authState,
      checkSkyanAuthorization,
      currentAccessToken,
      saveAuthentication,
    } = this.props;

    if (authState?.accessToken?.accessToken) {
      const {
        accessToken: { accessToken },
        idToken: { claims: user },
      } = authState;
      if (accessToken !== currentAccessToken) {
        saveAuthentication(user, accessToken);
        addEvent(Events.LOGIN);
        checkSkyanAuthorization();
      }
    }
  }

  render() {
    return null;
  }
}

Authenticated.propTypes = {
  addEvent: PropTypes.func.isRequired,
  authState: PropTypes.object,
  oktaAuth: PropTypes.object,
  saveAuthentication: PropTypes.func.isRequired,
  currentAccessToken: PropTypes.string,
  checkSkyanAuthorization: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    currentAccessToken: state.okta.accessToken,
    isEmployee: state.okta.isEmployee,
    isRolesLoaded: state.okta.isRolesLoaded,
  };
};

export default connect(mapStateToProps, {
  addEvent,
  checkSkyanAuthorization,
  saveAuthentication,
})(withOktaAuth(Authenticated));
